// @ts-nocheck
import { useState, useEffect } from 'react';
import { VERSES } from '@/data/verses';

const DRAWABLE = VERSES.filter(v => !v.isGap);

const RUMI_FRONT_IMAGES = [
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_style_01.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_style_02.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_style_03.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_door_01.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_door_02.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_door_03.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_door_04.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_door_05.png',
  'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_door_06.png'
];

function buildCardImages() {
  const map: Record<string, { front: string; back: string }> = {};
  let maryCount = 0;
  VERSES.forEach(v => {
    if (v.book === 'thomas' && !v.isGap) {
      const idx = String(v.number).padStart(3, '0');
      map[v.id] = {
        front: `https://storage.googleapis.com/wisdom-oracle-web/card-art/thomas-cards/thomas_s${idx}_front.png`,
        back: `https://storage.googleapis.com/wisdom-oracle-web/card-art/thomas-cards/thomas_s${idx}_back.png`
      };
      return;
    }
    if (v.book === 'mary' && !v.isGap) {
      maryCount++;
      const idx = String(maryCount).padStart(2, '0');
      map[v.id] = {
        front: `https://storage.googleapis.com/wisdom-oracle-web/card-art/mary-deck/cards/card_${idx}_front.png`,
        back: `https://storage.googleapis.com/wisdom-oracle-web/card-art/mary-deck/cards/card_${idx}_back.png`
      };
      return;
    }
    if (v.book === 'rumi' && !v.isGap) {
      const imgIdx = (v.number - 1) % RUMI_FRONT_IMAGES.length;
      map[v.id] = {
        front: RUMI_FRONT_IMAGES[imgIdx],
        back: 'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_title.png'
      };
    }
  });
  return map;
}

const CARD_IMAGES = buildCardImages();

export default function DrawScreen() {
  const [selectedDeck, setSelectedDeck] = useState<string>('thomas');
  const [drawnVerse, setDrawnVerse] = useState<any>(null);
  const [flipped, setFlipped] = useState(false);

  const handleDraw = () => {
    if (drawnVerse) {
      if (CARD_IMAGES[drawnVerse.id]) {
        setFlipped(!flipped);
      }
      return;
    }
    const pool = selectedDeck === 'all' ? DRAWABLE : DRAWABLE.filter(v => v.book === selectedDeck);
    if (pool.length === 0) return;
    const v = pool[Math.floor(Math.random() * pool.length)];
    setDrawnVerse(v);
    setFlipped(!CARD_IMAGES[v.id]);
  };

  const handleDeckChange = (deckId: string) => {
    setSelectedDeck(deckId);
    setDrawnVerse(null);
    setFlipped(false);
  };

  const handleReset = () => {
    setDrawnVerse(null);
    setFlipped(false);
  };

  const copyVerse = (v: any) => {
    const text = v.modern + '\n\n— ' + v.bookName + ', ' + v.label + '\n\nFrom The Mystic Oracle';
    navigator.clipboard.writeText(text).catch(console.error);
    alert('Copied to clipboard'); // Replace with toast later
  };

  return (
    <div id="draw" className="screen active" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px', color: 'var(--text-primary)' }}>
      
      {/* Visual Oracle Decks Selector */}
      <div className="decks-container" style={{ display: 'flex', gap: '16px', marginBottom: '32px', width: '100%', maxWidth: '420px', justifyContent: 'center' }}>
        {[
          { id: 'thomas', name: 'Thomas', desc: 'Thomas', image: 'https://storage.googleapis.com/wisdom-oracle-web/card-art/thomas-cards/thomas_s001_front.png', icon: '☥' },
          { id: 'mary', name: 'Mary', desc: 'Mary', image: 'https://storage.googleapis.com/wisdom-oracle-web/card-art/mary-deck/cards/card_01_front.png', icon: '❀' },
          { id: 'rumi', name: 'Rumi', desc: 'Rumi', image: 'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_style_01.png', icon: '❂' }
        ].map(deck => {
          const isActive = selectedDeck === deck.id;
          return (
            <div
              key={deck.id}
              onClick={() => handleDeckChange(deck.id)}
              style={{
                width: '110px',
                aspectRatio: '3/4',
                borderRadius: '12px',
                overflow: 'hidden',
                position: 'relative',
                cursor: 'pointer',
                border: isActive ? '2px solid var(--accent-primary)' : '1px solid var(--border)',
                boxShadow: isActive ? '0 0 16px rgba(212,168,68,0.35), var(--shadow-md)' : 'var(--shadow-sm)',
                transform: isActive ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                opacity: isActive ? 1 : 0.75
              }}
            >
              <img src={deck.image} alt={deck.name} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(5,5,15,0.95) 0%, rgba(5,5,15,0.1) 60%)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', padding: '10px 8px', textAlign: 'center' }}>
                <span style={{ fontSize: '1.1rem', marginBottom: '2px', color: isActive ? 'var(--accent-primary)' : 'white' }}>{deck.icon}</span>
                <span style={{ fontSize: '0.78rem', fontWeight: 600, color: '#fff', letterSpacing: '0.02em' }}>{deck.name}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="oracle-card-container" style={{ width: '100%', maxWidth: '420px', perspective: '1000px', margin: '0 auto' }}>
        <div className={`oracle-card ${flipped ? 'flipped' : ''}`} onClick={handleDraw} style={{ position: 'relative', width: '100%', minHeight: '350px', transition: 'transform 0.6s', transformStyle: 'preserve-3d', cursor: 'pointer' }}>
          
          <div className={`front ${(!drawnVerse || (drawnVerse && CARD_IMAGES[drawnVerse.id])) ? 'has-image' : ''}`} style={{ position: flipped ? 'absolute' : 'relative', inset: 0, backfaceVisibility: 'hidden', borderRadius: '16px', overflow: 'hidden', padding: (!drawnVerse || (drawnVerse && CARD_IMAGES[drawnVerse.id])) ? '0' : '40px', background: '#050510' }}>
            {!drawnVerse ? (
              <div style={{ position: 'relative', width: '100%', height: '100%', minHeight: '350px' }}>
                <img 
                  src={
                    selectedDeck === 'thomas' ? 'https://storage.googleapis.com/wisdom-oracle-web/card-art/thomas-cards/thomas_s001_front.png' :
                    selectedDeck === 'mary' ? 'https://storage.googleapis.com/wisdom-oracle-web/card-art/mary-deck/cards/card_01_front.png' :
                    'https://storage.googleapis.com/wisdom-oracle-web/card-art/rumi_style_01.png'
                  } 
                  alt="" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', opacity: 0.85 }} 
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(5,5,15,0.95) 0%, rgba(5,5,15,0.4) 50%, rgba(5,5,15,0.8) 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '32px 20px', textAlign: 'center' }}>
                  <div className="oracle-symbol" style={{ fontSize: '2.5rem', opacity: 0.8, color: 'var(--accent-primary)', textShadow: '0 0 10px rgba(212,168,68,0.5)' }}>&#x2726;</div>
                  <div>
                    <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.8rem', marginBottom: '8px', color: '#fff', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                      {selectedDeck === 'thomas' ? 'Gospel of Thomas' : selectedDeck === 'mary' ? 'Gospel of Mary' : 'Poems of Rumi'}
                    </h2>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', maxWidth: '280px', margin: '0 auto', textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
                      {selectedDeck === 'thomas' ? 'Desert Mysticism & Secret Sayings' : selectedDeck === 'mary' ? 'The Ascending Feminine Soul' : 'Ecstatic Cosmic Union'}
                    </p>
                  </div>
                  <div style={{ background: 'rgba(212,168,68,0.15)', border: '1px solid var(--accent-primary)', color: 'var(--accent-primary)', borderRadius: '30px', padding: '8px 20px', fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase', boxShadow: '0 0 15px rgba(212,168,68,0.2)' }}>
                    Tap to Draw
                  </div>
                </div>
              </div>
            ) : (
              drawnVerse && CARD_IMAGES[drawnVerse.id] && (
                <img src={CARD_IMAGES[drawnVerse.id].front} alt="" className="card-face-img" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: '16px' }} />
              )
            )}
          </div>

          <div className={`back ${drawnVerse && CARD_IMAGES[drawnVerse.id] ? 'has-image' : ''}`} style={{ position: flipped ? 'relative' : 'absolute', inset: 0, backfaceVisibility: 'hidden', transform: 'rotateY(180deg)', borderRadius: '16px', overflow: 'hidden', padding: drawnVerse && CARD_IMAGES[drawnVerse.id] ? '0' : '24px 20px', background: drawnVerse && CARD_IMAGES[drawnVerse.id] ? '#050510' : 'var(--bg-secondary)', border: '1px solid var(--border)' }}>
            {drawnVerse && CARD_IMAGES[drawnVerse.id] ? (
              <img src={CARD_IMAGES[drawnVerse.id].back} alt="" className="card-face-img" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', borderRadius: '16px' }} />
            ) : drawnVerse ? (
              <div style={{ minHeight: '300px' }}>
                <span className={`book-tag tag-${drawnVerse.book}`} style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', padding: '4px 12px', borderRadius: '20px', display: 'inline-block', marginBottom: '8px', background: 'var(--border)', color: 'var(--text-primary)' }}>{drawnVerse.bookName}</span>
                <div className="verse-num" style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '14px' }}>
                  {[drawnVerse.label, drawnVerse.source, drawnVerse.theme].filter(Boolean).join(' · ')}
                </div>
                <div className="verse-text" style={{ fontSize: '1.05rem', lineHeight: 1.7, fontFamily: 'Georgia, serif', color: 'var(--text-primary)' }}>{drawnVerse.modern}</div>
                <div className="literal" style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '14px', paddingTop: '14px', borderTop: '1px solid var(--border)', fontStyle: 'italic' }}>
                  {drawnVerse.literal.length > 200 ? drawnVerse.literal.substring(0, 200) + '...' : drawnVerse.literal}
                </div>
                <div className="card-actions" style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'center' }}>
                  <button onClick={(e) => { e.stopPropagation(); copyVerse(drawnVerse); }} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid var(--border)', color: 'var(--text-primary)', borderRadius: '20px', padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M16 3h-4a1 1 0 00-1 1v1h6V4a1 1 0 00-1-1z"/></svg> Share
                  </button>
                  <button disabled style={{ opacity: 0.4, cursor: 'default', background: 'rgba(255,255,255,0.06)', border: '1px solid var(--border)', color: 'var(--text-secondary)', borderRadius: '20px', padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg> Audio
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {drawnVerse && (
        <div className="card-details visible" style={{ margin: '24px auto 0', width: '100%', maxWidth: '500px', background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: '16px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div className="card-detail-header" style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', marginBottom: '10px' }}>
            <span className={`book-tag tag-${drawnVerse.book}`} style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', padding: '4px 12px', borderRadius: '20px', display: 'inline-block', background: 'var(--border)', color: 'var(--text-primary)' }}>{drawnVerse.bookName}</span>
            <div className="card-detail-meta" style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
              {[drawnVerse.label, drawnVerse.source, drawnVerse.theme].filter(Boolean).join(' · ')}
            </div>
          </div>
          <div className="card-detail-body" style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '16px' }}>
            <div className="card-detail-modern" style={{ fontSize: '0.98rem', lineHeight: '1.6', fontFamily: 'Georgia, serif', color: 'var(--text-primary)' }}>{drawnVerse.modern}</div>
            <div className="card-detail-literal" style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', fontStyle: 'italic', borderTop: '1px solid var(--border)', paddingTop: '10px', fontFamily: 'Georgia, serif' }}>{drawnVerse.literal}</div>
          </div>
          <div className="card-detail-actions" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button onClick={() => copyVerse(drawnVerse)} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid var(--border)', color: 'var(--text-primary)', borderRadius: '20px', padding: '8px 16px', fontSize: '0.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M16 3h-4a1 1 0 00-1 1v1h6V4a1 1 0 00-1-1z"/></svg> Share
            </button>
            <button disabled style={{ opacity: 0.4, cursor: 'default', background: 'rgba(255,255,255,0.06)', border: '1px solid var(--border)', color: 'var(--text-secondary)', borderRadius: '20px', padding: '8px 16px', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="11 5 6 9 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg> Audio
            </button>
          </div>
        </div>
      )}

      <button className={`draw-again ${drawnVerse ? 'visible' : ''}`} onClick={handleReset} style={{ display: drawnVerse ? 'inline-block' : 'none', marginTop: '20px', background: 'none', border: '1px solid var(--border)', color: 'var(--text-primary)', padding: '12px 28px', borderRadius: '30px', fontSize: '0.9rem', cursor: 'pointer' }}>
        Draw Again
      </button>

    </div>
  );
}
